/**
 * Extra routes spread by `app.routes.ts`.
 *
 * Nothing here is deleted — the components still live under `src/app/features/`
 * and are still type-checked, because `tsconfig.app.json` includes `src/**\/*.ts`.
 *
 * The admin subtree (`crew-board`, `crew-map`, `payroll`, `crew`, `cost-codes`)
 * is unreachable from the crew navigation — nothing in the app links to
 * `/:tenantId/admin` — and every one of those screens reads exclusively from
 * `MockDataService` with zero API integration. `change-orders` is API-backed
 * but absent from `navItems`, so it is URL-only.
 */
import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { adminGuard } from './core/guards/admin.guard';

/** `change-orders`, as a child of the `:tenantId/app` shell. */
export const excludedCrewRoutes: Routes = [
  {
    path: 'change-orders',
    loadComponent: () =>
      import('./features/change-orders/change-orders.component').then(m => m.ChangeOrdersComponent)
  }
];

/** The full tenant-scoped admin subtree. */
export const excludedAdminRoutes: Routes = [
  {
    path: ':tenantId/admin',
    loadComponent: () =>
      import('./features/admin/admin-layout/admin-layout.component').then(m => m.AdminLayoutComponent),
    canActivate: [authGuard, adminGuard],
    children: [
      { path: '', redirectTo: 'crew-board', pathMatch: 'full' },
      {
        path: 'crew-board',
        loadComponent: () =>
          import('./features/admin/crew-board/crew-board.component').then(m => m.CrewBoardComponent)
      },
      {
        path: 'map',
        loadComponent: () =>
          import('./features/admin/crew-map/crew-map.component').then(m => m.CrewMapComponent)
      },
      {
        path: 'payroll',
        loadComponent: () =>
          import('./features/admin/payroll/payroll.component').then(m => m.PayrollComponent)
      },
      {
        path: 'crew',
        loadComponent: () =>
          import('./features/admin/crew-management/crew-management.component').then(m => m.CrewManagementComponent)
      },
      {
        path: 'cost-codes',
        loadComponent: () =>
          import('./features/admin/cost-codes/cost-codes.component').then(m => m.CostCodesComponent)
      }
    ]
  }
];
